module.exports = __webpack_public_path__ + "img/logo-rino.538e3ef3.png";